<template>
  <ReferenceHandler @entryClicked="entryClicked">
    <Content :slice="replacedText"></Content>
  </ReferenceHandler>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import {ReferenceTool} from '@/components/common/lexicon/LexiconRefferenceTool'
import Content from "@/components/common/lexicon/LexiconOverlay/slices/Content"
import ReferenceHandler from "@/components/common/lexicon/LexiconOverlay/ReferenceHandler"
import LexiconAPI from "@/components/common/lexicon/LexiconAPI"

export default {
  name: 'FinLexiconText',
  components: {ReferenceHandler, Content},
  props: {
    /** the text where the markers are getting replaced */
    text: {type: [String, Array]},
    onlyEntry: {
      type: Boolean,
      default: true
    },
    autoSolve: {
      type: Boolean
    },
    autoSolveIgnoreWords: {
      type: Array
    }
  },
  data() {
    return {
      hideLexiconByEnvConfig: process.env.VUE_APP_HIDE_LEXICON === 'true',
      show: false,
      positionX: null,
      positionY: null,
      clickedElement: '',
      clickedElementArray: [],
      hideFunction: null
    }
  },
  computed: {
    replacedText() {
      const parserIndex = LexiconAPI.getParserIndex()

      const result = {
        primary: {
          text: [],
        },
        type: 'content'
      }
      if (Array.isArray(this.text)) {
        result.primary.text = this.text
      } else {
        const text = (this.text || '').replace(/<br\s*[/]?>/gi, '\n')
        result.primary.text.push({
          text,
          spans: [],
          type: "paragraph",
          lang: this.$i18n.locale
        })
      }

      if (!this.hideLexiconByEnvConfig && this.autoSolve) {
        result.primary.text.forEach(t => {
            if (t.autoParse !== false) {
              ReferenceTool.parseWords(t, parserIndex, this.autoSolveIgnoreWords)
            }
          }
        )
      }

      return result
    }
  },
  methods: {
    entryClicked(entry) {
      EventBus.$emit('showLexicon', entry?.ref, this.onlyEntry)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
